import { Box, Modal } from '@mui/material'
import { IModalTAG } from './types'
const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  padding: 0,
  maxHeight: '80vh',
  overflow: 'auto',
}

const ModalTAG: React.FC<IModalTAG> = ({ open, children, style = {} }) => {
  return (
    <Modal open={open} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, .8)' } }}>
      <Box sx={[modalStyle, style]}>{children}</Box>
    </Modal>
  )
}

export default ModalTAG
